const res = (state = false, action) => {
    switch(action.type){
        case "EGON":
            return state = action.value;
        default: return state
    }
}

export default res;